var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2141_114009",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 152,
    height: 152
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 75.5,
    fill: "#C4C4C4",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2141_114009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152 78C152 119.974 117.974 154 76 154C34.0264 154 0 119.974 0 78C0 36.0264 34.0264 2 76 2C117.974 2 152 36.0264 152 78Z",
    fill: "#E7E6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 99C83.123 99 89.9542 96.1554 94.9909 91.0919C100.028 86.0284 102.857 79.1608 102.857 72C102.857 64.8392 100.028 57.9716 94.9909 52.9081C89.9542 47.8446 83.123 45 76 45C68.877 45 62.0458 47.8446 57.0091 52.9081C51.9724 57.9716 49.1429 64.8392 49.1429 72C49.1429 79.1608 51.9724 86.0284 57.0091 91.0919C62.0458 96.1554 68.877 99 76 99ZM66.4112 109.125C45.7438 109.125 29 125.958 29 146.735C29 150.195 31.7906 153 35.2317 153H116.768C120.209 153 123 150.195 123 146.735C123 125.958 106.256 109.125 85.5888 109.125H66.4112Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfileUser);
export default __webpack_public_path__ + "static/media/no-profile-user.12a86ba0264ba060fc89d291690a90a3.svg";
export { ForwardRef as ReactComponent };